export const GPT_IMAGE_SIZE_OPTIONS = [
  { value: '1024x1024', label: '1024x1024', description: 'Square' },
  { value: '1536x1024', label: '1536x1024', description: 'Landscape' },
  { value: '1024x1536', label: '1024x1536', description: 'Portrait' },
  { value: '2048x2048', label: '2048x2048', description: '2K Square' },
  { value: '2048x1152', label: '2048x1152', description: '2K Landscape' },
  { value: '3840x2160', label: '3840x2160', description: '4K Landscape' },
  { value: '2160x3840', label: '2160x3840', description: '4K Portrait' },
] as const

export const GPT_IMAGE_DEFAULT_SIZE = '1024x1024'

export const GPT_IMAGE_QUALITY_OPTIONS = [
  { value: 'medium', label: 'Medium', description: 'Fast' },
  { value: 'high', label: 'High', description: 'Quality' },
] as const

export const GPT_IMAGE_DEFAULT_QUALITY = 'high'

const GPT_IMAGE_SIZE_TO_ASPECT_RATIO: Record<string, string> = {
  '1024x1024': '1:1',
  '1536x1024': '3:2',
  '1024x1536': '2:3',
  '2048x2048': '1:1',
  '2048x1152': '16:9',
  '3840x2160': '16:9',
  '2160x3840': '9:16',
}

const GPT_IMAGE_DEFAULT_SIZE_BY_ASPECT_RATIO: Record<string, string> = {
  '1:1': '1024x1024',
  '3:2': '1536x1024',
  '2:3': '1024x1536',
  '16:9': '2048x1152',
  '9:16': '2160x3840',
}

export function getAspectRatioForGptImageSize(size: string): string {
  return GPT_IMAGE_SIZE_TO_ASPECT_RATIO[size] || GPT_IMAGE_SIZE_TO_ASPECT_RATIO[GPT_IMAGE_DEFAULT_SIZE]
}

export function getDefaultGptImageSizeForAspectRatio(aspectRatio: string): string {
  return GPT_IMAGE_DEFAULT_SIZE_BY_ASPECT_RATIO[aspectRatio] || GPT_IMAGE_DEFAULT_SIZE
}
